import Storage, { KEY_E2E } from '@/common/services/Storage';

export const E2E_TESTS_ENABLED = Storage.getObject(KEY_E2E, Storage.STORAGE_LOCAL) === true;
